import UserPermissionsConstants from '../constants/UserPermissionsConstants';

const userUtils = {
  isNucleusCustomer(roles: Array<string> = []) {
    return roles.includes('nucleusCustomer');
  },
  isSingleFamilyPayPerListingCustomer(roles: Array<string> = []) {
    return roles.includes('singleFamilyLegacyCustomer');
  },
  getFeaturePermissions(roles: Array<string> = []) {
    const enabledPermissions: { [key: string]: boolean } = {};
    const isAdmin = roles.includes(UserPermissionsConstants.PERMISSION_ROLES.COMPANY_ADMIN);
    for (const key of Object.keys(UserPermissionsConstants.PERMISSIONS)) {
      enabledPermissions[key] =
        isAdmin ||
        roles.includes(
          UserPermissionsConstants.PERMISSION_ROLES[key as keyof typeof UserPermissionsConstants.PERMISSION_ROLES],
        );
    }
    return enabledPermissions;
  },
};

export default userUtils;
